import AbsComponent from "../AbsComponent";

export default class CharGemItem extends AbsComponent{
    constructor(_name='', _store={}, _actions={}, _router={}, _el='', _l10n={}){
        super(_name, _store, _actions, _router, _el, _l10n);
    }

    setting(_d, _d2, _usemapName, _parent){
        _d = _d.data;

        let itsMe = window.myChar.id === _d2.data.id;

        let templ = $(`
        <div class="point-gems">
            <div class="accessory-wrap">

                <!-- 보패1 -->
                <div class="soulshield">
                ${_d.soulshield_1?`
                    <div class="item-img soulshield-1" data-tooltip="${_d.soulshield_1.tooltip_string}">
                        <img src="${_d.soulshield_1.equip.item.icon}" alt="${_d.soulshield_1.equip.item.name}"  title="nc://bns.CharInfo/ItemTooltip?item=${_d.soulshield_1.tooltip_string}&compare=${itsMe?'false':'true'}">
                    </div>
                    <div class="item-name soulshield-1"><span class="${_d.soulshield_1.equip.item.grade}">${_d.soulshield_1.equip.item.name}</span></div>
                `:`
                    <div class="item-img soulshield-1"></div><div class="item-name"><span class="grade_none">${this.l10n.soulShield1}</span></div>
                `}
                </div>
                <!-- 보패2 -->
                <div class="soulshield">
                ${_d.soulshield_2?`
                    <div class="item-img soulshield-2" data-tooltip="${_d.soulshield_2.tooltip_string}">
                        <img src="${_d.soulshield_2.equip.item.icon}" alt="${_d.soulshield_2.equip.item.name}"  title="nc://bns.CharInfo/ItemTooltip?item=${_d.soulshield_2.tooltip_string}&compare=${itsMe?'false':'true'}">
                    </div>
                    <div class="item-name soulshield-2"><span class="${_d.soulshield_2.equip.item.grade}">${_d.soulshield_2.equip.item.name}</span></div>
                `:`
                    <div class="item-img soulshield-2"></div><div class="item-name"><span class="grade_none">${this.l10n.soulShield2}</span></div>
                `}
                </div>
                <!-- 보패3 -->
                <div class="soulshield">
                ${_d.soulshield_3?`
                    <div class="item-img soulshield-3" data-tooltip="${_d.soulshield_3.tooltip_string}">
                        <img src="${_d.soulshield_3.equip.item.icon}" alt="${_d.soulshield_3.equip.item.name}"  title="nc://bns.CharInfo/ItemTooltip?item=${_d.soulshield_3.tooltip_string}&compare=${itsMe?'false':'true'}">
                    </div>
                    <div class="item-name soulshield-3"><span class="${_d.soulshield_3.equip.item.grade}">${_d.soulshield_3.equip.item.name}</span></div>
                `:`
                    <div class="item-img soulshield-3"></div><div class="item-name"><span class="grade_none">${this.l10n.soulShield3}</span></div>
                `}
                </div>
                <!-- 보패4 -->
                <div class="soulshield">
                ${_d.soulshield_4?`
                    <div class="item-img soulshield-4" data-tooltip="${_d.soulshield_4.tooltip_string}">
                        <img src="${_d.soulshield_4.equip.item.icon}" alt="${_d.soulshield_4.equip.item.name}"  title="nc://bns.CharInfo/ItemTooltip?item=${_d.soulshield_4.tooltip_string}&compare=${itsMe?'false':'true'}">
                    </div>
                    <div class="item-name soulshield-4"><span class="${_d.soulshield_4.equip.item.grade}">${_d.soulshield_4.equip.item.name}</span></div>
                `:`
                    <div class="item-img soulshield-4"></div><div class="item-name"><span class="grade_none">${this.l10n.soulShield4}</span></div>
                `}
                </div>
                <!-- 보패5 -->
                <div class="soulshield">
                ${_d.soulshield_5?`
                    <div class="item-img soulshield-5" data-tooltip="${_d.soulshield_5.tooltip_string}">
                        <img src="${_d.soulshield_5.equip.item.icon}" alt="${_d.soulshield_5.equip.item.name}"  title="nc://bns.CharInfo/ItemTooltip?item=${_d.soulshield_5.tooltip_string}&compare=${itsMe?'false':'true'}">
                    </div>
                    <div class="item-name soulshield-5"><span class="${_d.soulshield_5.equip.item.grade}">${_d.soulshield_5.equip.item.name}</span></div>
                `:`
                    <div class="item-img soulshield-5"></div><div class="item-name"><span class="grade_none">${this.l10n.soulShield5}</span></div>
                `}
                </div>
                <!-- 보패6 -->
                <div class="soulshield">
                ${_d.soulshield_6?`
                    <div class="item-img soulshield-6" data-tooltip="${_d.soulshield_6.tooltip_string}">
                        <img src="${_d.soulshield_6.equip.item.icon}" alt="${_d.soulshield_6.equip.item.name}"  title="nc://bns.CharInfo/ItemTooltip?item=${_d.soulshield_6.tooltip_string}&compare=${itsMe?'false':'true'}">
                    </div>
                    <div class="item-name soulshield-6"><span class="${_d.soulshield_6.equip.item.grade}">${_d.soulshield_6.equip.item.name}</span></div>
                `:`
                    <div class="item-img soulshield-6"></div><div class="item-name"><span class="grade_none">${this.l10n.soulShield6}</span></div>
                `}
                </div>
                <!-- 보패7 -->
                <div class="soulshield">
                ${_d.soulshield_7?`
                    <div class="item-img soulshield-7" data-tooltip="${_d.soulshield_7.tooltip_string}">
                        <img src="${_d.soulshield_7.equip.item.icon}" alt="${_d.soulshield_7.equip.item.name}"  title="nc://bns.CharInfo/ItemTooltip?item=${_d.soulshield_7.tooltip_string}&compare=${itsMe?'false':'true'}">
                    </div>
                    <div class="item-name soulshield-7"><span class="${_d.soulshield_7.equip.item.grade}">${_d.soulshield_7.equip.item.name}</span></div>
                `:`
                    <div class="item-img soulshield-7"></div><div class="item-name"><span class="grade_none">${this.l10n.soulShield7}</span></div>
                `}
                </div>
                <!-- 보패8 -->
                <div class="soulshield">
                ${_d.soulshield_8?`
                    <div class="item-img soulshield-8" data-tooltip="${_d.soulshield_8.tooltip_string}">
                        <img src="${_d.soulshield_8.equip.item.icon}" alt="${_d.soulshield_8.equip.item.name}"  title="nc://bns.CharInfo/ItemTooltip?item=${_d.soulshield_8.tooltip_string}&compare=${itsMe?'false':'true'}">
                    </div>
                    <div class="item-name soulshield-8"><span class="${_d.soulshield_8.equip.item.grade}">${_d.soulshield_8.equip.item.name}</span></div>
                `:`
                    <div class="item-img soulshield-8"></div><div class="item-name"><span class="grade_none">${this.l10n.soulShield8}</span></div>
                `}
                </div>

            </div>
        </div>
        `);


        templ.find('area').on('click', e => {
            let data = e.currentTarget.dataset?.tooltip;
            if (e.shiftKey && data) {
                location.href = 'nc://bns.Common/ItemPreview?item=' + data;
            }
        })
        $(_parent).empty().append(templ);
    }

    addEvents(){
    }

} // end of class